module.exports = __webpack_public_path__ + "static/media/BackRight.92e28c4b.jpg";